import {NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {UserPageComponent} from './user/user-page';
import {FormsModule, ReactiveFormsModule}    from '@angular/forms';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ClipboardModule} from 'ngx-clipboard';

import {HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';

import {HttpService} from './services/http-service';
import {MessageService} from './services/message-service';
import {ModalService} from './services/modal-service';
import {ViewportService} from './services/viewport-service';

import {UserDetailsComponent} from "./user/user-details";
import {WalletDepositComponent} from "./wallet/wallet-deposit";
import {WalletWithdrawComponent} from "./wallet/wallet-withdraw";
import {WalletExchangeComponent} from "./wallet/wallet-exchange";
import {WalletStatusComponent} from "./wallet/wallet-status";
import {WalletTransactionsComponent} from "./wallet/wallet-transactions";
import {WalletTransactionComponent} from "./wallet/wallet-transaction";
import {StaticContentComponent} from "./other/static-content";
import {ContactPageComponent} from "./other/contact-page";
import {HarmonogramListComponent} from "./wallet/harmonogram-list";
import {HarmonogramEditComponent} from "./wallet/harmonogram-edit";
import {HarmonogramDetailsComponent} from "./wallet/harmonogram-details";
import {HarmonogramHistoryComponent} from "./wallet/harmonogram-history";
import {UserMenuComponent} from "./user/user-menu";
import {UserLoginStatusComponent} from "./user/user-login-status";
import {UserPersonalDataComponent} from "./user/user-personal-data";
import {UserPasswordChangeComponent} from "./user/user-password-change";
import {UserTransferTitleComponent} from "./user/user-transfer-title";
import {UserTransactionLimitComponent} from "./user/user-transaction-limit";
import {UserContactDataComponent} from "./user/user-contact-data";
import {BankAccountListComponent} from "./accounts/bank-account-list";
import {BankAccountEditComponent} from "./accounts/bank-account-edit";
import {BankAccountOwnerEditComponent} from "./accounts/bank-account-owner-edit";
import {BankAccountOwnersComponent} from "./accounts/bank-account-owners";
import {BankAccountsComponent} from "./accounts/bank-accounts";

import {CurrencyRatesComponent} from "./currency/currency-rates";
import {CurrencyRateComponent} from "./currency/currency-rate";
import {CurrencyCalculatorComponent} from "./currency/currency-calculator";
import {CurrencyRatesColumnComponent} from "./currency/currency-rates-column";
import {CurrencyCalculatorPageComponent} from "./currency/currency-calculator-page";
import {CurrencyRatesTableComponent} from "./currency/currency-rates-table";
import {CurrencyRatesHistoryComponent} from "./currency/currency-rates-history";
import {CurrencyRatesMobileBarComponent} from "./currency/currency-rates-mobile-bar";
import {InfoBoxComponent} from "./common/info-box";
import {MessageComponent} from "./common/message";
import {FormInlineRowComponent} from "./forms/form-inline-row";

import {DkNumberPipe} from "./pipes/dk-number";
import {DkSafeHtmlPipe} from "./pipes/dk-safe-html";
import {DkCurrencyInputDirective} from "./forms/dk-currency-input";
import {DkWatchScroll} from "./other/dk-watch-scroll";

import {DkNumberInputComponent} from './input-directives/dk-number-input';
import {DkDateInputComponent} from './input-directives/dk-date-input';

import {InfoPage} from './../app-pages/info-page';
import {LoginComponent} from "./user/login";

import {RavenErrorHandler} from './common/error-handler';
import { TextMaskModule } from 'angular2-text-mask';
import {UserDataStatusComponent} from "./user/user-data-status";

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {ModalContentComponent} from './other/chf_popup';
import {ModalMessageComponent} from './other/generic_popup';
import {ThirdPartyTransferAcceptComponent} from './accounts/third-party-accept';


let numeral = require('numeral');

let routes = [
    {path: '', redirectTo: 'panel-klienta/dane-osobowe.html', pathMatch: 'full'},
    {path: 'panel-klienta/dane-osobowe.html', component: UserDetailsComponent},
    {path: 'panel-klienta/dane-osobowe-portfel.html', component: UserDetailsComponent},
    {path: 'panel-klienta/konta-bankowe.html', component: BankAccountsComponent},
    {path: 'panel-klienta/wlasciciele-kont.html', component: BankAccountOwnersComponent},
    {path: 'panel-klienta/wplata.html', component: WalletDepositComponent},
    {path: 'panel-klienta/kalkulator-walutowy.html', component: CurrencyCalculatorPageComponent},
    {path: 'panel-klienta/kursy-walut.html', component: CurrencyRatesTableComponent},
    {path: 'panel-klienta/kursy-historyczne.html', component: CurrencyRatesHistoryComponent},
    {path: 'panel-klienta/wyplata.html', component: WalletWithdrawComponent},
    {path: 'panel-klienta/wymiana.html', component: WalletExchangeComponent},
    {path: 'panel-klienta/zlecenia-stale.html', component: HarmonogramListComponent},
    {path: 'panel-klienta/zlecenie-stale.html', component: HarmonogramEditComponent},
    {path: 'panel-klienta/zlecenie-stale.html/:id', component: HarmonogramEditComponent},
    {path: 'panel-klienta/moj-portfel.html', component: WalletStatusComponent},
    {path: 'panel-klienta/moje-transakcje.html', component: WalletTransactionsComponent},
    {path: 'panel-klienta/poradnik.html', component: StaticContentComponent},
    {path: 'panel-klienta/bank-czas-koszty.html', component: StaticContentComponent},
    {path: 'panel-klienta/rachunki-kantoru.html', component: StaticContentComponent},
    {path: 'panel-klienta/przelewy-zagraniczne-szczegoly.html', component: StaticContentComponent},
    {path: 'panel-klienta/zalecenia.html', component: StaticContentComponent},
    {path: 'panel-klienta/bezpieczenstwo-transakcji.html', component: StaticContentComponent},
    {path: 'panel-klienta/regulamin-kantoru.html', component: StaticContentComponent},
    {path: 'panel-klienta/pytania-i-odpowiedzi.html', component: StaticContentComponent},
    {path: 'panel-klienta/kontakt.html', component: ContactPageComponent},
    {path: 'panel-klienta/aktualnosci.html', component: StaticContentComponent},
    {path: 'panel-klienta/zlecenia-automatyczne.html', component: StaticContentComponent},
    {path: 'panel-klienta/zlecenia-automatyczne-szczegoly.html', component: StaticContentComponent},
    {path: 'panel-klienta/numery-iban.html', component: StaticContentComponent}
];

@NgModule({
    declarations: [
        UserPageComponent,
        UserDetailsComponent,
        WalletDepositComponent,
        WalletStatusComponent,
        StaticContentComponent,
        WalletWithdrawComponent,
        WalletExchangeComponent,
        HarmonogramListComponent,
        HarmonogramDetailsComponent,
        HarmonogramHistoryComponent,
        WalletTransactionsComponent,
        WalletTransactionComponent,
        HarmonogramEditComponent,
        UserMenuComponent,
        CurrencyRatesComponent,
        UserLoginStatusComponent,
        InfoBoxComponent,
        UserPersonalDataComponent,
        UserPasswordChangeComponent,
        UserContactDataComponent,
        UserTransferTitleComponent,
        BankAccountListComponent,
        BankAccountEditComponent,
        BankAccountOwnerEditComponent,
        BankAccountOwnersComponent,
        BankAccountsComponent,
        MessageComponent,
        FormInlineRowComponent,
        CurrencyRateComponent,
        DkNumberPipe,
        DkCurrencyInputDirective,
        UserTransactionLimitComponent,
        DkNumberInputComponent,
        DkDateInputComponent,
        DkSafeHtmlPipe,
        LoginComponent,
        ContactPageComponent,
        CurrencyCalculatorComponent,
        CurrencyCalculatorPageComponent,
        CurrencyRatesColumnComponent,
        CurrencyRatesTableComponent,
        CurrencyRatesHistoryComponent,
        CurrencyRatesMobileBarComponent,
        DkWatchScroll,
        UserDataStatusComponent,
        ModalContentComponent,
        ModalMessageComponent,
        ThirdPartyTransferAcceptComponent
    ],
    imports: [
        BrowserModule,
        RouterModule.forRoot(routes),
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forRoot(),
        HttpClientModule,
        ClipboardModule,
        TextMaskModule,
        NgbModule
    ],
    providers: [
        HttpService,
        ModalService,
        MessageService,
        ViewportService,
        DkNumberPipe,
        DkSafeHtmlPipe,
        { provide: ErrorHandler, useClass: RavenErrorHandler }
    ],
    bootstrap: [
        UserPageComponent
    ],
    entryComponents: [ ModalContentComponent, ModalMessageComponent ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})

export class UserPageModule {
    constructor() {
        numeral.register('locale', 'pl', {
            delimiters: {
                thousands: '',
                decimal: ','
            },
            abbreviations: {
                thousand: 'k',
                million: 'm',
                billion: 'b',
                trillion: 't'
            },
            ordinal : function (number) {
                return number === 1 ? '' : 'y';
            },
            currency: {
                symbol: 'zł'
            }
        });

        numeral.locale('pl');

        let infoPage = new InfoPage();
        infoPage.init();

    }
}